export * from './delete-objekt-art.component';
export * from './delete-objekt-art.component.module';